import { AlertTriangle, CheckCircle2, Info, XCircle } from 'lucide-react';
import type { ReactNode } from 'react';

import { cn } from '../../lib/cn.ts';

const styles = {
  info: { box: 'border-primary/30 bg-primary/5', icon: Info },
  success: { box: 'border-success/40 bg-success/10', icon: CheckCircle2 },
  warning: { box: 'border-warning/60 bg-warning/15', icon: AlertTriangle },
  danger: { box: 'border-danger/40 bg-danger/10', icon: XCircle },
} as const;

export function Alert({
  tone = 'info',
  title,
  children,
  className,
}: {
  tone?: keyof typeof styles;
  title?: string;
  children?: ReactNode;
  className?: string;
}) {
  const { box, icon: Icon } = styles[tone];
  return (
    <div
      role={tone === 'danger' ? 'alert' : 'status'}
      className={cn('flex gap-3 rounded-lg border p-3 text-sm', box, className)}
    >
      <Icon className="mt-0.5 size-4 shrink-0" aria-hidden="true" />
      <div className="space-y-1">
        {title && <p className="font-medium">{title}</p>}
        {children && <div>{children}</div>}
      </div>
    </div>
  );
}
